// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__2MZkk","decorativeLine":"footer_decorativeLine__gkkNB","content":"footer_content__+BANO","bottom":"footer_bottom__pW2O3"};